import React from 'react'
import { Table, Button } from 'semantic-ui-react'
import Single from '../../../componentes/Single'
import firebase from 'firebase/compat/app'
import 'firebase/compat/database'
import DateUtilities from '../../../componentes/DateUtilities'
import SubmitButton from '../../../componentes/submitButton/submitButton'
import {PositiveNumInput as Input} from '../../../componentes/PositiveNumInput/PositiveNumInput'

class Compra extends React.Component {
    constructor(props) {
        super(props)
        this.database = firebase.firestore()
        this.state = {
            compra: {
                herramienta: '',
                proveedor: '',
                precio: 0,
                cantidad: 0,
                total: 0
            },
            message: '',
            almacen: '',
            fecha: new Date()
        }
    }
    componentDidMount() {
        const firestore = firebase.firestore();
        const docRef = firestore.collection('Info').doc('info');

        docRef.get().then((doc) => {
        if (doc.exists) {
            this.setState({ almacen: doc.data().almPrincipal });
        } else {
            console.log('No such document!');
        }
        }).catch((error) => {
        console.log('Error getting document:', error);
        });
    }
    handleChange = async(e, { name, value }) => {
        const compra = { ...this.state.compra }
        compra[name] = value
        compra.total = compra.precio * compra.cantidad
        this.setState({ compra: compra })
    }
    handleSubmit = async () => {
        if (
            this.state.compra.herramienta === '' ||
            this.state.compra.proveedor === '' ||
            this.state.compra.precio === 0 ||
            this.state.compra.cantidad === 0
        ) {
            this.setState({ message: 'Llene todos los campos' })
            return null
        }

        const compras = firebase.firestore().collection('Compras')
        const inventario = firebase.firestore().collection('InventarioH')
        try {
            await compras.add({
                fecha: this.state.fecha,
                herramienta: this.state.compra.herramienta,
                proveedor: this.state.compra.proveedor,
                precio: this.state.compra.precio,
                cantidad: parseFloat(this.state.compra.cantidad),
                total: this.state.compra.total,
                tipo: 'herramienta'
            });
            for (let i = 0; i < this.state.compra.cantidad; i++) {
                await inventario.add({
                    herramienta:this.state.compra.herramienta,
                    ubicacion:this.state.almacen,
                    fechaCompra: this.state.fecha,
                    fecha: this.state.fecha,
                });
            }
            this.setState({
                message: 'Compra  agregada con éxito',
                compra: {
                    herramienta: '',
                    proveedor: '',
                    precio: 0,
                    cantidad: 0,
                    total: 0,
                }
            })
        }
        catch (e) {
            console.log(e)
            this.setState({
                message: 'Ocurrió un error!',
            })
        }
    }
    render() {
        return (
            <section>
                <h3>Nueva Compra</h3>
                <div>
                    <Single placeholder='Nombre' search tabla='Herramientas'
                    columna='nombre' onChange={this.handleChange} 
                    name='herramienta' value={this.state.compra.herramienta} />
                    <Single placeholder='Proveedor' search tabla='Proveedores' columna='nombre' onChange={this.handleChange} name='proveedor' value={this.state.compra.proveedor} />
                    <Input label='Cantidad' type='number' onChange={this.handleChange} value={this.state.compra.cantidad} name='cantidad' />
                    <Input label='Precio Unitario' type='number' onChange={this.handleChange} value={this.state.compra.precio} name='precio' />
                    <Input label='Total' type='number' value={this.state.compra.total} name='total' disabled />
                    <SubmitButton handleSubmit={this.handleSubmit}>Enviar</SubmitButton>
                </div>
                <p>{this.state.message}</p>
                <TablaCompras />
            </section>
        )
    }
}

class TablaCompras extends React.Component {
    constructor(props) {
        super(props)
        this.database = firebase.firestore()
        this.state = {
            rows: []
        }
    }
    componentDidMount() {
        this.listCompras('mes')
    }
    listCompras = (timespan) => {
        if (timespan !== 'todo') {
            let first = null
            if (timespan === 'mes') {
                first = DateUtilities.getFirstDayOfMonth()
            }
            else if (timespan === 'año') {
                first = DateUtilities.getFirstDayOfYear()
            }
            this.database.collection('Compras')
                .where('fecha', '>', first)
                .where("tipo", "==", "herramienta")
                .orderBy('fecha', 'desc')
                .onSnapshot(snap => {
                    const rows = []
                    for (let i = 0; i < snap.docs.length; i++) {
                        rows.push(snap.docs[i].data())
                    }
                    this.setState({
                        rows: rows
                    })
                })
            return null
        }
        this.database.collection('Compras')
            .orderBy('fecha', 'desc')
            .onSnapshot(snap => {
                const rows = []
                for (let i = 0; i < snap.docs.length; i++) {
                    rows.push(snap.docs[i].data())
                }
                this.setState({
                    rows: rows
                })
            })
    }
    changeTimespan = (timespan) => {
        this.listCompras(timespan)
    }
    render() {
        return (
            <section>
                <div><h3>Historial</h3>
                    <Button onClick={() => { this.changeTimespan('mes') }}>Este Mes</Button>
                    <Button onClick={() => { this.changeTimespan('año') }}>Este Año</Button>
                    <Button onClick={() => { this.changeTimespan('todo') }}>Ver Todos</Button>
                </div>
                <div  className="body tabla">
                    <table><tbody>
                        <tr>
                            <th>Nombre</th>
                            <th>Proveedor</th>
                            <th>Cantidad</th>
                            <th>Precio</th>
                            <th>Total</th>
                            <th>Fecha</th>
                        </tr>
                        {this.state.rows.map((row, i) => {
                            return (
                                <Table.Row key={i}>
                                    <Table.Cell>{row.herramienta}</Table.Cell>
                                    <Table.Cell>{row.proveedor}</Table.Cell>
                                    <Table.Cell>{`${row.cantidad} unidades`}</Table.Cell>
                                    <Table.Cell>{row.precio}</Table.Cell>
                                    <Table.Cell>{row.total}</Table.Cell>
                                    <Table.Cell>{row.fecha.toDate().toLocaleDateString()}</Table.Cell>
                                </Table.Row>
                            )
                        })}
                    </tbody></table>
                </div>
            </section>
        )
    }
}

export default Compra